import React, { useState, useCallback } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

export default function SearchInput({
  value,
  onChange,
  placeholder,
  className = '',
  debounceMs = 300
}) {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState(value || '');
  const [debounceTimer, setDebounceTimer] = useState(null);
  
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    
    const timer = setTimeout(() => {
      onChange(newValue);
    }, debounceMs);
    
    setDebounceTimer(timer);
  }, [onChange, debounceMs, debounceTimer]);
  
  const handleClear = useCallback(() => {
    setLocalValue('');
    onChange('');
  }, [onChange]);
  
  return (
    <div className={`relative ${className}`}>
      <div className="absolute inset-y-0 left-0 rtl:left-auto rtl:right-0 flex items-center pl-3 rtl:pl-0 rtl:pr-3 pointer-events-none">
        <MagnifyingGlassIcon className="w-5 h-5 text-gray-400" />
      </div>
      <input
        type="text"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder || t('common.search')}
        className="input pl-10 rtl:pl-3 rtl:pr-10"
      />
      {localValue && (
        <button
          onClick={handleClear}
          className="absolute inset-y-0 right-0 rtl:right-auto rtl:left-0 flex items-center pr-3 rtl:pr-0 rtl:pl-3"
        >
          <XMarkIcon className="w-5 h-5 text-gray-400 hover:text-gray-600" />
        </button>
      )}
    </div>
  );
}
